import { useCurrentSpace, useSpaces } from './use-spaces'

const baseTitle = 'AbaSupport'
const pageTitle = ref('')

export function setDocumentTitle(title: string) {
  pageTitle.value = title
}

export function useDocumentTitle() {
  const { hasMultipleSpaces } = useSpaces()
  const { currentSpaceInfo, getSpaceLabel } = useCurrentSpace()

  const spaceLabel = computed(() =>
    hasMultipleSpaces.value && currentSpaceInfo.value
      ? getSpaceLabel(currentSpaceInfo.value)
      : '',
  )

  useTitle(() =>
    pageTitle.value
      ? [pageTitle.value, spaceLabel.value, baseTitle]
          .filter(Boolean)
          .join(' - ')
      : baseTitle,
  )
}
